export const analyticsFromModule = {
  name: 'Analytics From',
};
